/**
 * 渐进充值余额卡头图：按盘替换时改此函数或接配置中心。
 * 默认使用宿主充值页头图资源。
 */
export function getRechargeWebBalanceHeaderBgSrc(): string {
  return require('@/assets/imgs/recharge-header-bg.png');
}
